import { createFileRoute, redirect } from "@tanstack/react-router";
import { DEFAULT_LANG } from "@/i18n/config";

/** The root URL has no language of its own: send visitors to the Dutch site. */
export const Route = createFileRoute("/")({
  staticData: { sitemap: false },
  head: () => ({ meta: [
    { title: "Zwembadbouw en renovatie | Gopro Projects Limburg" },
    { name: "description", content: "Gopro Projects uit Maasmechelen bouwt bouwkundige zwembaden en renoveert polyester monoblocks." },
    { property: "og:title", content: "Zwembadbouw en renovatie | Gopro Projects Limburg" },
    { property: "og:description", content: "Bouwkundige zwembaden en monoblockrenovatie vanuit Maasmechelen." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" },
  ] }),
  beforeLoad: () => {
    throw redirect({ to: "/$lang", params: { lang: DEFAULT_LANG }, statusCode: 302 });
  },
});
